import { render, staticRenderFns } from "./product-add-modal.vue?vue&type=template&id=43d2bcf2&scoped=true&"
import script from "./product-add-modal.vue?vue&type=script&lang=js&"
export * from "./product-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-add-modal.vue?vue&type=style&index=0&id=43d2bcf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2bcf2",
  null
  
)

export default component.exports